import "../sellscreendialogs.scss";
import { type FC, useCallback, useState } from "react";
import { useShopfrontDispatch } from "../../../../_Bootstrap/hooks";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { type SaleAddGiftCardOptions } from "../../../../Actions/SellScreen/SellScreenProductActions";
import { addGiftCardToSale } from "../../../../Actions/SellScreen/SellScreenProductActions";
import Button from "../../../../Common/Buttons/Button";
import PopupManager from "../../../../Common/Popups/PopupManager";
import TouchNumbers from "../../../../Common/TouchNumbers/TouchNumbers";
import { currency, getCurrencyDecimalPlaces } from "../../../../Utilities/Generic/Numbers";

export const RequestAmount: FC<SaleAddGiftCardOptions> = (options) => {
    const [ value, setValue ] = useState("");
    const dispatch = useShopfrontDispatch();
    const addAmount = useCallback((validateAmount = false) => {
        const amount = parseFloat(value);

        if(isNaN(amount)) {
            PopupManager.error("Invalid gift card amount provided");

            return;
        }

        if(validateAmount && amount > 9999) {
            PopupManager.create({
                message: `To create a gift card with a value of ${currency(amount)}, please click Add`,
                icon   : "exclamation",
                classes: [ "popup-warning" ],
                timeout: 10000,
            });

            return;
        }

        if(amount <= 0) {
            PopupManager.error("The gift card amount must be greater than zero");

            return;
        }

        dispatch(hideDialog());
        dispatch(addGiftCardToSale({
            ...options,
            amount,
        }));
    }, [ dispatch, options, value ]);

    return (
        <div className="request-amount">
            <p>Please enter the gift card&apos;s value</p>
            <TouchNumbers
                static
                hideConfirm
                input="currency"
                value={value}
                onChange={val => setValue(val)}
                onConfirm={() => addAmount(true)}
                autoFocus
                bounds={{
                    max          : false,
                    min          : 0,
                    decimalPlaces: getCurrencyDecimalPlaces(),
                }}
            />
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-save" ]}
                    onClick={() => addAmount()}
                >
                    Add
                </Button>
            </div>
        </div>
    );
};
